/* eslint-disable @next/next/no-img-element */
import { Group, Image } from "@mantine/core"

import { HeaderNavBarButton } from "@/components/generic/HeaderNavBar/components/HeaderNavButton"

// import { OngoingCallWidget } from "@/components/generic/HeaderNavBar/components/OngoingCallWidget"
const BASE_TEST_ID = "headernavbar-"

export function HeaderNavBar() {
  //   const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
  //     useDisclosure(false)
  //   const [linksOpened, { toggle: toggleLinks }] = useDisclosure(false)
  //   const theme = useMantineTheme()

  return (
    <header
      data-testid={`${BASE_TEST_ID}container`}
      className="h-16 bg-r-blue px-4 dark:bg-r-blue-dark-mode"
    >
      <Group justify="space-between" h="100%">
        <div className="flex items-center justify-start gap-6">
          <Image
            data-testid={`${BASE_TEST_ID}logo`}
            alt="Ring.io"
            className="h-6"
            src="/assets/ringio_complete_logo.png"
          />

          <Group gap="xs" data-testid={`${BASE_TEST_ID}calls-container`}>
            {/* <OngoingCallWidget calleeName="TestTestTestTestTest" isRinging />
            <OngoingCallWidget
              calleeName="TestTestTestTestTest"
              isRinging
              isOutgoing
            />
            <OngoingCallWidget calleeName="Test 2" isSelected /> */}
          </Group>
        </div>

        <Group
          visibleFrom="sm"
          gap="xs"
          data-testid={`${BASE_TEST_ID}right-actions-container`}
        >
          {/* <HeaderNavBarButton type="ReferAFriend" /> */}
          {/* <HeaderNavBarButton type="SupportChat" /> */}
          {/* <HeaderNavBarButton type="Notifications" /> */}
          <HeaderNavBarButton type="Profile" />
        </Group>
      </Group>
    </header>
  )
}
